import React , {useState, useContext, useEffect } from 'react';
import axios from "axios";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import {ProductContext} from "../../ProductProvider";
import {Breadcrumb, BreadcrumbItem, Alert } from "reactstrap";
import RequestList from './RequestList';
import Preloader from "../../components/Preloader";
import { Routes } from "../../routes";
import useFileDownloader from "./useFileDownloader";

const config = require('../../config.json');


export default function MyRequestList() {

    const { loggedUser, alertClose, alertDetails, setAlertDetails, validateLogin } = useContext(ProductContext);
    const [searchResults, setSearchResults]=useState([]);
    const [loaded, setLoaded] = useState(true);
    const [downloadFile, downloaderComponentUI] = useFileDownloader();

      useEffect(()=>{
        if(loggedUser.isAuthenticated){
          alertClose();
          fetchMyRequest();
        }else{
        validateLogin();
        alertClose();
        }
        return()=>{
          alertClose();
        }
       // console.log(batchYear);
      },[loggedUser])

      const fetchMyRequest =async()=>{
        try {
            setLoaded(false);
                const session = await Auth.currentSession();
                const access_token=session.idToken.jwtToken;
                const familyname="SJMDU";
                const searchOption="MyRequest";
                const searchValue=loggedUser.name;
                const res = await axios.get(`${config.api.invokeUrl}/user_request?searchValue=${searchValue}&searchOption=${searchOption}&familyName=${familyname}`,{
                    headers:{
                        Authorization: access_token,
                        'x-api-key': config.api.key
                    }
                });
                //console.log("res DAta : ", res);
                setAlertDetails({
                    ...alertDetails,
                    style:"success",
                    open:true,
                    message: res.data.length + " - request found"
                }); 
                window.scrollTo(0,0); 
               /* var i=0;
                while(i<res.data.length){
                //  console.log("before value : ", res.data[i].Book_Classification_No);
                 const tempClassValue= [...bookClassification].filter(searchresult =>searchresult.value===res.data[i].Book_Classification_No);
                 res.data[i].Book_Classification_No=tempClassValue[0].name;
                 //console.log("temp class vale : ", tempClassValue);
                 //console.log("After update : ", res.data[i].Book_Classification_No);
    
                 i++;
                }*/
                
                setSearchResults(res.data);
                setLoaded(true);
                //hideLoader();
            
        } catch (error) {
            setLoaded(true);
            setAlertDetails({
                ...alertDetails,
                style:"warning",
                open:true,
                message:"Error Occured - " + error.message
            }); 
            window.scrollTo(0,0); 
        }
      }

    const handleCancelRequest=async(event, req)=>{
        event.preventDefault();
       // console.log("Item : ", req);
        try {
            setLoaded(false);

              const tCloseDate= await assignInitialValues();
              const session = await Auth.currentSession();
              const access_token=session.idToken.jwtToken;
              const { communityName, reqNo, reqRaisedBy }=req;
              const params = {
                  "communityName": communityName,
                  "reqNo": reqNo,
                  "reqStatus": "Cancelled",
                  "reqRaisedBy":reqRaisedBy,
                  "reqWorkedBy": reqRaisedBy,    
                  "reqCloseDate": tCloseDate,
                  "reqResolutionNotes":"Cancelled by User"
              };
         //     console.log(" Params : ", params);
              const reqid=reqNo;
        // await axios.post(`${config.api.invokeUrl}/user_request/${reqid}`, params,{
           await axios.patch(`${config.api.invokeUrl}/user_request/${reqid}`, params,{
            headers: {
            Authorization: access_token,
            'x-api-key':config.api.key
          }})
          .then(async()=>{
            //console.log("response : ", response); 
              setAlertDetails({
                ...alertDetails,
                style:"success",
                open:true,
                message:reqid + " - Cancelled Successfully"
            }); 
             // handleCancelClick(event);
             //resetRequestValues();
             fetchMyRequest();
             setLoaded(true);
          })
          .catch((error)=>{
              setAlertDetails({
                ...alertDetails,
                style:"warning",
                open:true,
                message: "Error Occured : " + error.message
            }); 
            setLoaded(true);
          })
        
      
      }catch (err) {
            setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message:"Error Occured - " + err.message
      }); 
      setLoaded(true);
      }
      
    }

      const assignInitialValues=()=>{
        const current_datetime = new Date();
        const tusername=loggedUser.name.trim().replace(/\s/g, "");
        const tempUserId= tusername.substring(0,4);
        var tempCreateDate="";
        var tempCreateTime="";
        const date_year = (current_datetime.getFullYear()).toString().substring(2,4);
        var date_month = (current_datetime.getMonth() + 1).toString();
        var month_value="";
        date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
        var date_date = (current_datetime.getDate().toString());
        var date_value="";
        date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
        var date_hours = (current_datetime.getHours().toString());
        var hours_value="";
        date_hours.length===1?(hours_value=hours_value.toString().concat(0,date_hours)):(hours_value=date_hours);
        var date_minutes = (current_datetime.getMinutes().toString());
        var minutes_value="";
        date_minutes.length===1 ?(minutes_value=minutes_value.toString().concat(0,date_minutes)):(minutes_value=date_minutes);
        //const accountNo = tempUserId.concat(date_year,month_value, date_value, hours_value, minutes_value);
        const accCreateDate = tempCreateDate.concat(date_year,"-",month_value,"-", date_value);
        //const accCreateTime = tempCreateTime.concat(hours_value,":", minutes_value);
    
        //setUserId(accountNo);
        return accCreateDate;
      
      
      }

      const handleAttachmentDownload=async(event, searchresult)=>{
        event.preventDefault();
        console.log("Event");
          try{
            const fetchFile=searchresult.attachmentName;
            const bucketName=config.s3.attachmentBucketName;
            //const bucketName=`idnticauseraccountspdfinvoicesourcebucket/pdfs/invoice/${propsFile.clientId}`;
            /*const params={
                fileName:fetchFile,
                bucketName:`idnticauseraccountspdfinvoicesourcebucket/pdfs/invoice/${propsFile.clientId}/${propsFile.domainId}`
            };*/
            const session = await Auth.currentSession();
            const access_token=session.idToken.jwtToken;
            await axios.get(`${config.api.invokeUrl}/presigned/downloader?fileName=${fetchFile}&bucketName=${bucketName}`,{
              headers: {
                Authorization: access_token,
                'x-api-key': config.api.key
              }}, 
           ).then(async(response)=>{
                console.log("Response : ", response);
                const file ={
                    name:searchresult.attachmentName,
                    file:response.data.downloadURL,
                    filename:fetchFile
                };
                //console.log("url file : ", file);
                downloadFile(file);
            }).catch((error)=>{
                //console.log("Error : ", error);
                //setDispMsg("Error Occured - ", error.message);
            })        
          }catch(error){
              //console.log("Error : ", error);
          }
      
  
      }
      
    
  return (
    <div className="m-2">
         <Preloader show={loaded ? false : true} />
         <Breadcrumb>
    <BreadcrumbItem>
      <Link to={Routes.LandingPage.path}>
        Home
      </Link>
    </BreadcrumbItem>
    <BreadcrumbItem >
      Request
    </BreadcrumbItem>
    <BreadcrumbItem >
      My Request
    </BreadcrumbItem>
  </Breadcrumb>
  <h5 className="mb-4">My Request</h5>

<Alert color={alertDetails.style} fade={true} isOpen={alertDetails.open} toggle={alertClose} >
{alertDetails.message}
</Alert>
        <RequestList searchResults={searchResults} handleCancelRequest={handleCancelRequest} handleAttachmentDownload={handleAttachmentDownload}/>
        {downloaderComponentUI}

    </div>
  )
}
